import { defineMessages } from 'react-intl';

export default defineMessages({
  imageAlt: {
    id: 'shared.tenuredGoldMedal.imageAlt',
    defaultMessage: 'Star badge celebrating your membership',
    description: 'Image alt message for screen readers',
  },
});
